import type { SxProps, Theme } from "@mui/material/styles";

export const snackbar: SxProps<Theme> = {
  bottom: { xs: 88, md: 24 },
};

export const alert: SxProps<Theme> = {
  width: "100%",
  minWidth: { sm: 320 },
  maxWidth: 480,
  alignItems: "center",
  borderRadius: 2,
  boxShadow: 3,
  lineHeight: 1.7,
};
